export default "__VITE_ASSET__rJdi1sek__"